import { render, staticRenderFns } from "./CustomFieldDatePicker.vue?vue&type=template&id=0508f2e6&scoped=true"
import script from "./CustomFieldDatePicker.vue?vue&type=script&lang=ts"
export * from "./CustomFieldDatePicker.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldDatePicker.vue?vue&type=style&index=0&id=0508f2e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508f2e6",
  null
  
)

export default component.exports